<body>
    <app-account-header></app-account-header>
    <div class="clear40"></div>
    <div class="d-flex align-items-center auth px-0 mt-5">
        <div class="row w-100 mx-0 mt-5">
            <div class="col-lg-4 mx-auto">
                <label class="txtblack fs-20 semi-bold"><img routerLink="/change-password" class="mr-2 cp outline-0" src="./assets/images/backarrow.png">Forgot Password</label>
                <div class="clear5"></div>
                <div class="auth-form-light bg-white">

                    <form>
                        <h6 class="fs-16 txtblack semi-bold mb-3">Enter Your Registered Email Address 1</h6>
                        <div class="form-group">
                            <input type="email" class="form-control forminput {{showregemailErrorMsg?'border-red':''}}" [(ngModel)]="regEmail" (input)="regemailErrorMsg();" name="email" placeholder="" autocomplete="off">
                            <span class="error-msg" *ngIf="showregemailErrorMsg">Please Enter Registered Email Address</span>

                        </div>

                        <div class="clear10"></div>


                        <div class="mt-3">
                            <div class="row">


                                <div class="col-sm-7 col-md-7">
                                    <a class="btn btn-block  blue-btn semi-bold fs-16" (click)="forgotPassword()">GET RESET LINK</a>

                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</body>